/**
 * Created by SH: 20/02/2020
 */

import { ReelEngineController } from "../../core/reel/ReelEngineController";
import { GameSetting } from "../../core/setting/GameSetting";
import { SanEnginePlayer } from "./SanEnginePlayer";
import { SanSpriteSymbol } from "./Symbol/SanSpriteSymbol";
import { SanSymbolData } from './Symbol/SanSymbolData';

export class SanEngineView extends ReelEngineController {

    protected attentionStop: boolean = false;

    public moveYOffsetOld:number = 0;
    public moveYOffsetNew:number = 0;

    public get engine(): SanEnginePlayer { return this._engine as SanEnginePlayer; }

    public get AllSymbols(): SanSpriteSymbol[] { return this._symbolContainer.children as SanSpriteSymbol[]; }

    public get topSymbol(): SanSpriteSymbol { return this.AllSymbols[0]; }
    public get bottomSymbol(): SanSpriteSymbol { return this.AllSymbols[this.AllSymbols.length - 1]; }

    public get windowTopSymbol(): SanSpriteSymbol { return this.AllSymbols[this.overflowAmount] }
    public get windowBottSymbol(): SanSpriteSymbol { return this.AllSymbols[this.AllSymbols.length - (1 + this.overflowAmount)]; }

    public get AllWindowSymbols(): SanSpriteSymbol[] {
        return this.AllSymbols.filter(sym => { return (Math.max(...sym.posID) >= 0 && Math.min(...sym.posID) < (this.symbolConfAmount - this.overflowAmount*2)) });
    }

    public get stopDuration(): number {
        if (GameSetting.isFastSpin || this.isQuickStop) return this.config.DURATION.FAST_STOP;
        else if (this.attentionStop) return this.config.DURATION!.ATTENTION_STOP!;
        return this.config.DURATION.STOP;
    }

    public get stopDelay(): number {
        if (GameSetting.isFastSpin || this.isQuickStop) return this.config.DELAY.FAST_STOP;
        return this.config.DELAY.STOP;
    }

    public get stopEase(): any {
        return GameSetting.isFastSpin || this.isQuickStop ? this.config.EASING.FAST_STOP : this.config.EASING.STOP;
    }

    public getSymbol(symbolID: number): SanSpriteSymbol | undefined {
        return super.getSymbol(symbolID) as SanSpriteSymbol;
    }

    createReelEngine(): void {
        this._engine = new SanEnginePlayer(this.engineCallbacks(), this._animationContainer);
        this._engine.stepDistance = this.maxHeight/this.config.WINDOW_AMOUNT;
    }

    protected setVisibleForOverflowSymbols(value: boolean): void {
        if (!this.isActive) return;

        for (let indx: number = 0; indx < this.AllSymbols.length; indx++) {
            const posID: number[] = this.AllSymbols[indx].posID;
            if (Math.max(...posID) < 0 || Math.min(...posID) >= this.windowConfAmount) this.AllSymbols[indx].visible = value;
        }
    }
}
